import React from 'react';
import PropTypes from 'prop-types';
import { Pencil, X, Check } from 'lucide-react';

const ActionButton = ({ variant, onClick, className = '' }) => {
  const variants = {
    edit: {
      icon: Pencil,
      text: 'Edit',
      classes: 'text-blue-600 hover:text-blue-700',
    },
    cancel: {
      icon: X,
      text: 'Cancel',
      classes: 'text-gray-600 hover:text-gray-700',
    },
    save: {
      icon: Check,
      text: 'Save',
      classes: 'text-green-600 hover:text-green-700',
    },
  };

  const config = variants[variant];
  const Icon = config.icon;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-1 text-xs transition ${config.classes} ${className}`}
    >
      <Icon className="w-3 h-3" />
      {config.text}
    </button>
  );
};

ActionButton.propTypes = {
  variant: PropTypes.oneOf(['edit', 'cancel', 'save']).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

ActionButton.defaultProps = {
  className: '',
};

export default ActionButton;